export default __webpack_public_path__ + "static/media/whiteArrow.53fe52bb.svg";